
import {Component, ElementRef, ViewChild} from '@angular/core';
import {AppGlobalEventManagerService} from '../../../services/app.globalEventManager.service';
import {dossierJ} from '../../../interfaces/dossierJ.interface';
import {PeopleWithrightsInterface} from '../../../interfaces/peopleWithrights.interface';
import {ROLES} from '../../../datas/roles.helpers';
import {JplusBlocked, JplusWarning} from '../../../../modules/DOnet/models/JPlus';
import {Drawer} from 'primeng/drawer';
import {IntraDoOperationApi, IntraDoSinistre, IntraDoSinistreApi} from '../../../../shared/sdk';
import {AppToasterService} from '../../../services/app.toaster.service';
import {ModalCompatibilityService} from '../../../services/modal-compatibility.service';
import {
  AjoutSuiviModaleDirective
} from '../../../../modules/DOnet/directives/modales/sinistre/ajoutSuiviModale/ajoutSuiviModale.directive';
import moment from 'moment';
import {NgClass} from '@angular/common';
import {RouterLink} from '@angular/router';
import {Tooltip} from 'primeng/tooltip';
import {
  SinistreSliderPartial
} from '../../../../modules/DOnet/directives/partials/sinistreSlider/sinistreSlider.partial';
import {AppSessionService} from '../../../services/app.session.service';
import {TranslocoPipe} from '@jsverse/transloco';
import {Accordion, AccordionContent, AccordionHeader, AccordionPanel} from 'primeng/accordion';
import {EditButtonDirective} from '../../custom/buttons/edit/buttons.edit.directive';
import {ButtonsTableEditDirective} from '../../custom/buttons/tableEdit/buttons.tableEdit.directive';
import {TableModule} from 'primeng/table';
import {
  SeeHistoriqueSinistreModaleDirective
} from '../../../../modules/DOnet/directives/modales/sinistre/seeHistoriqueSinistreModale/seeHistoriqueSinistreModale.directive';

@Component({
  selector: 'sidebarJplus',
  standalone: true,
  imports: [
    Drawer,
    NgClass,
    RouterLink,
    Tooltip,
    SinistreSliderPartial,
    TranslocoPipe,
    AccordionPanel,
    Accordion,
    AccordionHeader,
    AccordionContent,
    EditButtonDirective,
    ButtonsTableEditDirective,
    TableModule,
  ],
  templateUrl: './sidebarJplus-partial.html'
})
export class SidebarJplusPartial {

  public showJPlus: boolean = false;
  public nbJBlocked: number = 0
  public nbJWarning: number = 0
  public listBlocked: dossierJ[] = [];
  public listWarning: dossierJ[] = [];

  public user: PeopleWithrightsInterface;

  public colRightIsActive = false;

  constructor(
    public appGlobalEventManagerService: AppGlobalEventManagerService,
    public _sessionService: AppSessionService,
    private _ebOperationApiService: IntraDoOperationApi,
    public intraSinistreService: IntraDoSinistreApi,
    public _toastr: AppToasterService,
    private modalService: ModalCompatibilityService,
  ){

    this.appGlobalEventManagerService.J30Emitter.subscribe((res) => {
      this.showJPlus = res;
    })

    this.appGlobalEventManagerService.listSinistresJ30Emitter.subscribe((res: dossierJ[]) => {
      this.nbJBlocked = res.length;
      this.listBlocked = res;
    })

    this.appGlobalEventManagerService.listSinistresJ27Emitter.subscribe((res) => {
      this.nbJWarning = res.length;
      this.listWarning = res;
    })

    this._sessionService.logguedAccountEmitter.subscribe((people) => {
      this.user = people;
    })

    this.appGlobalEventManagerService.columnJPlusEmitter.subscribe((res) => {
      this.colRightIsActive = res;
    })


  }

  toggleSidebar(){
    this.colRightIsActive = !this.colRightIsActive;
    this.appGlobalEventManagerService.updateColumnJPlus(this.colRightIsActive);
  }

  openModaleAjoutSuivi(sinistre:any, operation:any){
    this.intraSinistreService.findOne({where: {id: sinistre.sinistreId}}).subscribe((sinistreObj: IntraDoSinistre) => {
      const activeModal = this.modalService.open(AjoutSuiviModaleDirective, { size: 'xl', centered: false });
      this.returnSaveModaleReloadLine(activeModal, sinistreObj, sinistreObj.operation);
    })
  }

  openModaleHistorique(sinistre:any){
    const activeModal = this.modalService.open(SeeHistoriqueSinistreModaleDirective, { size: 'xl', centered: false });
    activeModal.componentInstance.sinistreId = sinistre.sinistreId;
  }

  public returnSaveModaleReloadLine(activeModal, sinistre:any, operation:any){
    activeModal.componentInstance.sinistre = sinistre;
    activeModal.componentInstance.operation = operation;
    activeModal.componentInstance.clickeventUpdateSinistre.subscribe((ret:IntraDoSinistre) => {
      if(ret){
        activeModal.close();
        // Ask for reloading list !
        this.reload();

      }else{
        this._toastr.error('Une erreur s\'est produite', 'Problème');
      }
    })
  }

  reload(){
    // DUPLICAT
    this._ebOperationApiService.hasDossierJ(JplusWarning, JplusBlocked).subscribe((res) => {
      if(res && res[JplusBlocked] && res[JplusBlocked].length > 0){

        let GoblockDateAG = true;
        if(this.user && this.user.dateNoLimitAG){
          GoblockDateAG = moment(this.user.dateNoLimitAG, 'YYYY-MM-DD').isBefore(moment())
        }

        this.appGlobalEventManagerService._j30.next(GoblockDateAG); // Trigger Blocage J+30 + readonly sur dossiers != de la liste ! + Ne peut avoir que le volet de droite sur actualisation
        this.appGlobalEventManagerService._listSinistresJ30.next(res[JplusBlocked]);
        this.appGlobalEventManagerService._listSinistresJ27.next(res[JplusWarning]);
        this.nbJBlocked = res[JplusBlocked].length;
        this.nbJWarning = res[JplusWarning].length;
      } else {
        this.appGlobalEventManagerService._j30.next(false);
        this.appGlobalEventManagerService._listSinistresJ30.next([]);
        this.appGlobalEventManagerService._listSinistresJ27.next([]);
      }
    })
  }


  protected readonly JplusBlocked = JplusBlocked;
  protected readonly JplusWarning = JplusWarning;
  protected readonly ROLES = ROLES;

}
